import { render, staticRenderFns } from "./CrudConfig.vue?vue&type=template&id=7a490fa2&scoped=true&"
import script from "./CrudConfig.vue?vue&type=script&lang=js&"
export * from "./CrudConfig.vue?vue&type=script&lang=js&"
import style0 from "./CrudConfig.vue?vue&type=style&index=0&id=7a490fa2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a490fa2",
  null
  
)

export default component.exports